<template>
  <div
    v-if="isError"
    class="poster"
    :style="`background: rgb(0,0,0);`"
  >
    <div class="bodydiv" :style="`padding-bottom: 27px;`">
      <img src="https://oss.turingsenseai.com/1757499398253376653.jpg" class="logo">
      <div class="ccic-top">
        <img :src="exteriorUrl" alt="">
        <div class="ccic-top-text">
          <div class="series-name">
            {{ seriesName }}
          </div>
          <div class="brand-name">
            {{kindName ? kindName : ''}}{{ brandName ? '｜' + brandName : '' }}
          </div>
          <div class="case-code" @click="copyCode(OAID)">
            Case Code: <span class="case-code" style="color: #3C78F0;">{{ OAID ? OAID : '-' }}</span>
            <img src="../../../assets/images/ai-picture/copy.png" alt="" class="copy-img">
          </div>
        </div>
      </div>
    <div class="info">
      <div class="title">
        Progress of AI
      </div>
      <div class="progress">
        <span class="ps" :style="{left: '100%'}">100%</span>
        <div class="wb" :style="{left: '98%'}">
          <img src="https://oss.turingsenseai.com/1760685628495797145.jpg" style="width: 100%;height: 100%;" alt="">
        </div>
      </div>
      <template v-if="isResult">
        <span class="_ii Insufficient" v-if="genuine == '3'">
          Insufficient Images
        </span>
        <img v-else :src="getResultImage(false)" class="res">
      </template>
      <template v-else>
        <span class="_ii blue">Under appraisal...</span>
      </template>
      <div class="images">
        <div class="image" :class="{check: curr && i.image === curr.image}" v-for="(i, index) in SARecordList" @click="checkPoint(SARecordList, index)" :key="i.image" style="display: inline-block; margin-right: 10px;">
          <van-image :src="i.image" class="pic" :show-loading="false" fit="contain"></van-image>
          <img src="https://oss.turingsenseai.com/1757325100397942751.jpg" class="fd" @click.stop="previewImage(SARecordList, index)">
          <div class="name">{{ i.pointName ? i.pointName : "-" }}</div>
        </div>
      </div>
      <div class="scord" v-if="curr && curr.grade && gradeProcess(curr.grade) !== 'NaN'">
        <div class="bar">
          <span class="ps" :style="{left: `${gradeProcess(curr.grade)}%`}">{{ gradeProcess(curr.grade) }}points</span>
          <div class="wb" :style="{left: `${gradeProcess(curr.grade)}%`}"></div>
        </div>
        <div class="points">
          <span class="p">0points</span>
          <span class="p">100points</span>
        </div>
      </div>
     </div>

      <div class="human">
        <div class="title">
          Progress of Human Experts
        </div>
        <div class="progress">
          <span class="ps" :style="{left: '100%'}">50%</span>
          <div class="wb" :style="{left: '50%'}">
            <img src="https://oss.turingsenseai.com/1760687494935471081.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
        </div>
        <div class="intro">
          Human experts' results are expected to be available within 24 hours.
        </div>
      </div>

      <div class="foot-text">
        <div class="title center" v-if="genuine == '3'">Insufficient Images</div>
        <div class="title center" v-else>CERTIFICATE of {{ genuine === '1' ? 'Authenticity' : genuine === '0' ? 'Counterfeit' :genuine === '2' ? 'Inconclusive' : '' }}</div>
        <div class="intro">
          <span>TikTok official authentication service provider</span>
          <span>Serve over 5 million users around the world</span>
          <span>Generate 10k certificates daily</span>
          <span>Certified by ISO9001:2015 Quality Management System</span>
        </div>
      </div>

      <div
        v-if="!ifFake"
        class="share"
        :style="`height: 89px;${isPcFlag ? 'width: 100vw;' : ''}`"
        @click="show = !show"
      >
        <span style="margin-top: 10px;"
          >Share Report</span
        >
      </div>
      <div v-if="!ifFake" style="height: 100px;"></div>
    </div>
    <van-popup
      :class="clientWidth > 500 ? 'boswer_poster' : 'poster'"
      v-model="show"
      position="bottom"
      :lock-scroll="true"
      :lazy-render="false"
      closeable
      @opened="savePic"
      :style="{
        height: '70vh',
        width: clientWidth > 500 ? '575px' : '',
        overflow: 'hidden',
      }"
    >
      <div class="pc-mark" v-show="pcMark"><van-loading /></div>
      <div class="poster_title">
        <span>Save to Album</span>
      </div>
      <vue-canvas-poster
        :widthPixels="0"
        :painting="painting"
        @success="success"
        @fail="fail"
      ></vue-canvas-poster>
      <div
        class="poster_container"
        style="width:100%;height:100%;justify-content: center;display:flex;margin-top:20px"
      >
        <img
          v-if="posterPic"
          style="height:400px;width:250px;-webkit-touch-callout: none;"
          :src="posterPic"
          alt=""
        />
      </div>
      <van-button
        style="position: fixed;bottom:0px;"
        class="save"
        type="primary"
        size="large"
        @click="download"
        >Click Or Long Press To Save The Image</van-button>
    </van-popup>

    <div
      v-if="isPcFlag ? false : true"
      style="width:100vw;height:100%;position: absolute;top:0;z-index:9999;background-color:#4C4C4C;opacity: 0.8;display: flex;justify-content: center;align-items: center;"
      :style="saveLoading ? '' : 'display:none;'"
    >
      <van-loading size="60px" />
    </div>
    <div id="ai-report-qrcode" style="display:none"></div>
  </div>
</template>

<script>
import "@/common/js/watermark.js";
import { Toast, ImagePreview } from 'vant'
import bg0 from "@/assets/images/ccic-picture/ccic.png";
// import bg2 from "@/assets/images/appraisal/header.png";
import bg1 from "@/assets/images/appraisal/ai.png";
// import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { HOST_ADDRESS } from "../../../common/constant";
import { fetchZpReportDetail } from "@/common/api/appraisal.js";
// import * as htmlToImage from "html-to-image";
// import { saveAsPng, saveAsJpeg } from "save-html-as-image";

// http://localhost/#/zp-report/AI9V6I11

const result = {
  0: "https://oss.turingsenseai.com/1757401577606913789.jpg",
  1: "https://oss.turingsenseai.com/1757401677193715138.jpg",
  2: "https://oss.turingsenseai.com/1757401758685672443.jpg",
  3: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

const _result = {
  0: "https://oss.turingsenseai.com/1757401650181389158.jpg",
  1: "https://oss.turingsenseai.com/1757320608953400642.jpg",
  2: "https://oss.turingsenseai.com/1757401753109406966.jpg",
  3: "https://oss.turingsenseai.com/1757580810774680425.jpg"
}

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      eleLoading: false,
      saveLoading: false,
      pcMark: false,
      ccic: bg0,
      ai: bg1,
      header: "https://oss.turingsenseai.com/1633945620360284110.png",
      isError: false,
      clientWidth: "",
      imgData: "",

      showMore: true,
      descList: [],

      // 获取数据
      isAI: false,
      ifFake: false, // 是否符合
      noAppraisal: false,
      isHaveManualResult: false,
      kindName: "",
      brandName: "",
      seriesName: "",
      description: "",
      ifLosePic : false,
      descriptionList: [],
      exteriorUrl: "", // 外观图片URL
      appraisalTime: [],
      SARecordList: [], // 详情鉴定列表
      precent: 0,
      genuine: "",
      OAID: "",
      fakePoints: [],
      exteriorUrlList: [],
      qrcode: "",
      // 弹出层
      show: false,
      backBase64: "",
      exteriorBase64: "",
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      DBwidth: "",
      // 海报图片
      posterPic: "",
      isPosterPic: true,
      isPcFlag: "",
      Flag: true,
      openError: false,
      aa: "https://oss.turingsenseai.com/1628575872053959757.png",
      bb: "https://oss.turingsenseai.com/1628679598180643073.png",
      cc: "https://oss.turingsenseai.com/1628582036592914079.png",
      painting: {},
      isResult: false,
      curr: "",
    };
  },
  methods: {
    copyCode(id){
      this.$copyText(id).then(res => {
        Toast.success('已复制')
      })
    },
    download() {
      let imgData = this.posterPic;
      this.downloadFile('poster.png', imgData);
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    success(src) {
      this.posterPic = src;
    },
    fail(err) {
      console.log(err);
    },
    async getData() {
      this.isPcFlag = this.IsPc();
      this.clientWidth = window.clientWidth;
      // this.isAI = this.$route.params.ai == 0 ? true : false;
      // console.log(isAI);
      let OAIDARY = this.$route.params.appraisalno.split("-"); // 不符合 AIIOVGQT 符合 AIZ0A9L8 中检不符合 AI1RUMJ0 符合 AI7XSULH
      let OAID = "";
      if (OAIDARY.length > 1) {
        OAID = OAIDARY[0] + OAIDARY[1];
      } else {
        OAID = OAIDARY[0];
      }
      await fetchZpReportDetail({ OAID }).then((res) => {
        this.isError = true;
        if (res.errorMsg == "Success") {
          console.log("请求res",res);
          // res.genuine = 0
          // genuine： 1 真 2 假 3 无法 4 待补图

          this.genuine = res.genuine; // 1 真 2 假 3 无法 4 待补图
          // this.genuine = 4;
          
          this.ifFake = res.genuine != "1"; // 假+无法+待补图 需要取消注释

          this.ifLosePic = this.genuine == "4"; // 缺图 需要取消注释

          this.noAppraisal = res.genuine == "3" ? false : true; // false 为无法鉴别  需要取消注释
          
          if(res.manualResult !== 0) {// 没有manualResult字段就以genuine为准
            // res.manualResult = 3
            // this.cc = "https://oss.turingsenseai.com/1718098287629255884.jpg"
            // manualResult: 1: 真 2:假 3:无法鉴别 4：待补图
            this.genuine = res.manualResult; //  1 真 2 假 3 无法 4 待补图
            this.ifFake = res.manualResult !== 1; // 假+无法+待补图
            this.noAppraisal = res.manualResult !== 3; 
            this.ifLosePic = res.manualResult == 4; // 缺图
          }
          if(res.appraisalType === 2) { //1: AI 2: 人工
            this.setArtificialImage()
          }
          this.kindName = res.kindName;
          this.brandName = res.brandName;
          this.seriesName = res.seriesName;
          this.description = res.description;
          this.descriptionList.push(res.description.slice(0, 22));
          this.descriptionList.push(res.description.slice(21, 44));
          let lastText = `${res.description.slice(43, 55)}`;
          this.descriptionList.push(lastText);
          this.exteriorUrl = `data:image/png;base64,${res.exteriorUrl}`;
          this.curr = res.SARecordList[0] || null
          this.OAID = res.OAID;
          this.precent = res.grade * 100; //综合评分
          this.SARecordList = JSON.parse(JSON.stringify(res.SARecordList));
          this.isResult = this.genuine ? true : false;
          this.appraisalTime = res.appraisalTime.split(" ")[0].split("-");
          this.descList = this.description.split("\n");
        } else {
          this.isError = false;
        }
      });
      await this.createQrCode();
      this.painting = {
        width: `1254px`,
        height: `1920px`,
        background: this.isHaveManualResult ? "https://oss.turingsenseai.com/1718264748178773416.jpg" : "https://oss.turingsenseai.com/1634095646634913220.png",
        views: [
          {
            type: "text",
            text: this.brandName,
            css: {
              top: "905px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "text",
            text: this.OAID,
            css: {
              top: "1007px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "image",
            url: this.imgData,
            css: {
              top: "1450px",
              left: "900px",
              width: "220px",
              height: "220px",
            },
          },
        ],
      };
    },
    setArtificialImage() {
      this.aa = "https://oss.turingsenseai.com/1718098287626995203.jpg"
      this.bb = "https://oss.turingsenseai.com/1718098287611010672.jpg"
      this.isHaveManualResult = true
    },
    descShowMore(flag) {
      flag ? (this.showMore = false) : (this.showMore = true);
    },
    saveImage() {
      const link = document.createElement("a");

      link.download = "poster.png";
      link.href = this.posterPic;
      console.log(link);
      link.click();
    },
    getResultImage(outside=true){
      if(outside){
        return _result[this.genuine]
      }
      return result[this.genuine]
    },
    savePic() {
      // 没啥用
      if (this.openError) {
        Toast.loading({
          message: "图片加载失败请刷新重试",
        });
      }
    },
    getBase64Image(url, callback) {
      this.eleLoading = true;
      let Img = new Image(),
        dataURL = "";
      // Math.random()
      Img.src = url + "?v=" + Math.random();
      Img.setAttribute("crossOrigin", "Anonymous");
      try {
        Img.onload = function() {
          let canvas = document.createElement("canvas"),
            width = Img.width,
            height = Img.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
          let quality = 0.1;
          dataURL = canvas.toDataURL("image/jpeg", quality);
          while (dataURL.length / 1024 > 150) {
            quality -= 0.01;
            dataURL = canvas.toDataURL("image/jpeg", quality);
          }
          this.eleLoading = false;
          return callback ? callback(dataURL) : null;
        };
      } catch (error) {
        this.openError = true;
      }
    },
    async createQrCode() {
      new QRCode(document.getElementById("ai-report-qrcode"), {
        text: `${HOST_ADDRESS()}ai-report/${this.$route.params.appraisalno}`, // 需要转换为二维码的内容
        // text: `${HOST_ADDRESS()}wallet`,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: 1,
      });

      let canvas = document
        .getElementById("ai-report-qrcode")
        .getElementsByTagName("canvas");
      this.imgData = canvas[0].toDataURL("image/png");
    },

    IsPc() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      return flag;
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(",");
      //注意base64的最后面中括号和引号是不转译的
      var _arr = arr[1].substring(0, arr[1].length - 2);
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    shareH5() {
      console.log("share");
    },
    test(e) {
      console.log(e);
    },
    previewImage(points, index){
      ImagePreview({
        images: points.map(i => i.image),
        startPosition: index,
      });
    },
    checkPoint(points, index){
      this.curr = points[index]
    },
    gradeProcess(grade){
      return (Number(grade)*100).toFixed(0)
    },
  },
};
</script>

<style lang="scss">
// vant组件样式
.van-tabs__wrap {
  height: 70px !important;
  .van-tabs__nav {
    // display: inline-block;
    padding: 0;
    // width: 10%;
    .van-tab {
      padding: 0;
      margin-right: 40 * 2px;
      display: inline-block;
      color: #828393;
      text-align: center;
      .van-tab__text {
        font-size: 0.9em;
      }
    }
    // .van-tab:nth-last-child(2) {
    //   margin-right: 0;
    // }
    .van-tab--active {
      &::after {
        content: "";
        width: 0;
        position: absolute;
        top: 1.9em;
        left: 50%;
        height: 0;
        transform: rotate(90deg) translateY(16%);
        border-bottom: 1em solid #2a2a30;
        border-left: 0.3em solid #2a2a30;
      }
      padding-bottom: 0.2em;
      color: #2a2a30;
      font-weight: 500;
    }
  }
  .van-tabs__line {
    display: none;
  }
}
body {
  background: linear-gradient(270.23deg, #26262e 0.15%, #4d4d59 99.76%);
}
.pc-mark {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.logo{
  height: 28px;
  margin-bottom: 32px;
  object-fit: contain ;
}
// 遮罩层
.water-mark {
  position: fixed;
  width: 100%;
  max-width: 750px;
  height: 100%;
  z-index: 5;
}
.cant_indt {
  width: 100%;
  .no_title {
      // text-align: center;
      // margin-left: 20px;
      background-color: #fff;
      font-weight: 500;
    }
    .reason {
      background-color: #fff;
      display: flex;
      flex-direction: column;
      width: 100%;
      // margin: 0 auto;
      color: #828393;
      font-weight: 400;
      p {
        line-height: 17 * 2px;
      }
    }
}

// 组件样式
.bodydiv {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 32px;
  font-size: 20px;
  height: 100%;
  min-height: 100vh;
  p,
  span {
    font-size: 20px;
    display: inline-block;
  }
  .bottom-detail {
    margin-top: -1px;
    background-color: white;
    // border-radius: 20px;
    width: 100%;
    margin-bottom: 20px;
    z-index: 6;
    .no_title {
      // text-align: center;
      // margin-left: 20px;
      font-weight: 500;
    }
    .reason {
      display: flex;
      flex-direction: column;
      width: 94%;
      margin: 0 auto;
      color: #828393;
      font-weight: 400;
    }
    .detail_title,
    .detail_container {
      margin: 3% 4%;
      .tag {
      }
    }
    
    .detail_container {
      // .detail_point {
      //   font-size: 0.8em;
      // }
      .point_content {
        width: 100%;
        border-top: 1px solid RGB(240, 240, 245);
        .precent {
          position: relative;
          margin-top: 14%;
          .linear {
            width: 100%;
            height: 10px;
            background-color: #b3d9fc;
            background: linear-gradient(90deg, #557AFF 0%, #4642FF 6.41%, #FF5572 102.62%);
          }
          .position_text {
            width: 150px;
            position: absolute;
            top: -2.1em;
            transform: scale(0.8) translateX(-14%);
            font-weight: 700;
            font-size: 1em;
          }
          .position {
            width: 0.2em;
            height: 18px;
            background-color: black;
            position: absolute;
          }
          .precent_tip {
            display: flex;
            justify-content: space-between;
            span {
              font-size: 0.9em;
              color: RGB(168, 168, 180);
            }
          }
        }
        .ponit_pic {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: row;
          margin: 20px 0;
          .picT,
          .picF {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
              width: 265px;
              height: 265px;
            }
          }
          .picF {
            position: relative;
            .fake_mark {
              position: absolute;
              border: 1px solid red;
              z-index: 7;
              border-radius: 45px;
              width: 9%;
              height: 8%;
            }
          }
          .pic_markT {
            position: absolute;
            top: 0;
            z-index: 6;
            width: 60%;
            height: 94%;
          }
          .pic_markF {
            position: absolute;
            top: 0;
            z-index: 6;
            height: 3.5rem;
            width: 3.5rem;
          }
          img {
            width: 35%;
            height: 35%;
            background-color: black;
            object-fit: contain;
            margin-bottom: 10px;
          }
          .trueArea {
            position: absolute;
            background-color: rgba(0, 0, 0, 0);
          }
          .trueP {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .truePic {
              width: 60%;
              height: 60%;
              background-color: black;
              object-fit: contain;
              margin-bottom: 10px;
            }
          }
          p {
            color: RGB(181, 181, 181);
          }
        }
        .point_dsc {
          margin: 0 auto;
          width: 100%;
          margin-bottom: 30px;
          // border-radius: 15px;
          background-color: RGB(248, 248, 251);
          // border: 1px solid RGB(238, 238, 238);
          p {
            padding: 20px;
          }
        }
      }
    }
  }
  .ccic-top {
    width: 2 * 343px;
    height: 2 * 84px;
    // height: 20vh;
    border-radius: 2 * 16px;
    background: #2F2F2F;
    position: relative;
    display: flex;
    align-items: center;
    margin: 15px 0 30px 0;
    z-index: 4;
    img {
      width: 2 * 60px;
      height: 2 * 60px;
      border-radius: 2 * 8px;
      margin-left: 28px;
    }
    .ccic-top-text {
      height: 2 * 60px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      color: #fff;
      margin-left: 20px;
      .series-name {
        font-size: 2 * 13px;
      }
      .brand-name,.case-code{
        color: #DBDBDB;
        font-size: 2 * 12px;
      }
      .copy-img{
        width: 2 * 12px;
        height: 2 * 12px;
        cursor: pointer;
        margin-left: 8px;
        margin-top: -2px;
      }
    }
  }
  .info{
    background-color: #2F2F2F;
    width: 343*2px;
    border-radius: 32px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: start;
    flex-direction: column;
    .title{
      font-weight: 600;
      font-size: 2 * 16px;
      color: #fff;
      margin-top: 6px;
    }
    ._ii{
      color: #fff;
      font-weight: 600;
      font-size: 2 * 20px;
    }
    .Insufficient{
      color: #1e9fff;
      font-size: 45px;
      margin-bottom: 20px;
    }
    .blue{
      color: #1e9fff;
      margin-bottom: 20px;
    }
    .res{
      object-fit: contain;
      height: 86px;
      margin-bottom: 16px;
    }
    .check{
    border: 4px solid #3B95FF !important;
      .name{
        background-color: #3B95FF !important;
      }
    }
    .progress{
      margin-top: 2 * 5px;
      width: 90%;
      height: 2 * 10px;
      border-radius: 2 * 8px;
      margin-bottom: 2 * 8px;
      position: relative;
      background: linear-gradient(270.02deg, #3971F6 0.75%, #77D6F6 100.54%);
      .ps{
        color: #fff;
        font-size: 2 * 10px;
        font-weight: 400;
        position: relative;
        right: 0px;
        margin-left: 12px;
        bottom: 7px;
        transition: all 0.3s linear;
      }
      .wb{
        height: 2 * 20px;
        width: 2 * 20px;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s linear;
      }
    }
    .images{
      width: 319*2px;
      display: flex; 
      overflow-x: auto; 
      white-space: nowrap; 
      -webkit-overflow-scrolling: touch; 
      scrollbar-width: none; 
      -ms-overflow-style: none;
      
      .image{
        // height: 180px;
        // width: 180px;
        width: 2 * 90px;
        height: 2 * 90px;
        flex-shrink: 0;
        overflow: hidden;
        border-radius: 16px;
        position: relative;
        border: 4px solid #2F2F2F;

        &:not(:last-child){
          margin-right: 16px;
        }

        .fd{
          position: absolute;
          object-fit: contain;
          width: 30px;
          height: 30px;
          right: 10px;
          bottom: 10px;
        }

        .name{
          background-color: #0C0C0C;
          max-width: 100%;
          padding: 4px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 20px;
          font-weight: 400;
          border-radius: 0 0 16px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .pic{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .scord{
      margin-top: 44px;
      display: flex;
      flex-direction: column;
      width: 100%;

      .bar{
        position: relative;
        width: 100%;
        height: 12px;
        border-radius: 6px;
        background: linear-gradient(90deg, rgba(58, 148, 255, 0.14) 0%, #3287FF 102.62%);

        .ps{
          color: #fff;
          font-size: 2 * 12px;
          font-weight: 400;
          position: absolute;
          bottom: 12px;
          transform: translateX(-50%);
          margin-bottom: 2px;
          transition: all 0.3s linear;
        }

        .wb{
          height: 100%;
          width: 8px;
          background-color: #fff;
          position: absolute;
          transition: all 0.3s linear;
        }
      }

      .points{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .p{
          color: #DBDBDB;
          font-size: 2 * 11px;
          font-weight: 400;
          margin-top: 6px;
        }
      }
    }
  }
  .human{
    background-color: #2F2F2F;
    width: 343*2px;
    border-radius: 32px;
    padding: 24px;
    margin-top: 2 * 15px;
    box-sizing: border-box;
    display: flex;
    align-items: start;
    flex-direction: column;
    .title{
      font-weight: 600;
      font-size: 2 * 16px;
      color: #fff;
      margin-top: 6px;
    }
    .progress{
      margin-top: 2 * 7px;
      width: 90%;
      height: 2 * 10px;
      border-radius: 2 * 8px;
      margin-bottom: 2 * 8px;
      position: relative;
      background: linear-gradient(90deg, #77D6F6 0%, #3971F6 50%, #334057 50%, #334057 100%);
      .ps{
        color: #fff;
        font-size: 2 * 10px;
        font-weight: 400;
        position: relative;
        right: 0px;
        margin-left: 12px;
        bottom: 7px;
        transition: all 0.3s linear;
      }
      .wb{
        height: 2 * 25px;
        width: 2 * 25px;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s linear;
      }
    }
    .intro{
      margin-top: 2 * 5px;
      font-size: 2 * 12px;
      color: #DBDBDB;
    }
  }
  .foot-text{
    width: 343*2px;
    border-radius: 32px;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    .title{
      color: white;
      font-size: 2 * 16px;
      font-weight: 600;
      width: 2 * 122px;
      line-height: 1.5;
    }
    .center{
      text-align: center;
    }
    .intro{
      color: #DBDBDB;
      font-size: 2 * 10px;
      font-weight: 400;
      width: 2 * 295px;
      margin-top: 2 * 2px;
      text-align: center;
      line-height: 1.5;
    }
  }
}
// 中检底部
.ccic-bottom {
  width: 100%;
  // height: 26vh;
  position: relative;
  z-index: 6;
  img {
    width: 100%;
  }
  // background-size: 100% 31vh;
  // background-image: url(https://oss.turingsenseai.com/1624005265917545236.png);
}
// 分享
.shaer_mark {
  width: 100%;
  position: relative;
}
.share {
  height: 2 * 50px;
  width: 100vw;
  z-index: 6;
  position: fixed;
  bottom: 2 * 6px;
  max-width: 750px;
  display: flex;
  justify-content: center;
  span {
    width: 94%;
    background: linear-gradient(271.38deg, #3A94FF 2.99%, #74C8F5 100%);
    color: #fff;
    display: inline-block;
    height: 2 * 50px;
    text-align: center;
    font-size: 2 * 17px;
    line-height: 2 * 50px;
    border-radius: 2 * 100px;
  }
}
// 海报

.poster {
  .poster_title {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    background-color: #f7f7f7;
    color: #363636;
    span {
      font-size: 1.1em;
      margin-left: 2%;
    }
  }
  // .poster_container {
  //   // width: 100%;
  //   // display: flex;
  //   // justify-content: center;
  //   // align-items: center;
  //   overflow: scroll;
  //   width: 73%;
  //   margin: 0 auto;
  //   margin-top: 2vh;
  //   display: flex;
  //   align-items: center;
  //   .back_img {
  //     // transform: translate(2vh, 3vh);
  //     width: 100%;
  //     background-repeat: no-repeat;
  //     .back_IMG {
  //       width: 73%;
  //       // height: 70vh;
  //       position: absolute;
  //       z-index: -1;
  //     }
  //     .isAI_mark {
  //       height: 14vh;
  //     }
  //     .back_title {
  //       font-size: 1.5em;
  //       font-weight: 600;
  //       color: #0a4074;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       // margin-bottom: 10px;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       // align-items: center;
  //       // margin-bottom: 2vh;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           // align-items: center;
  //           margin-bottom: 20px;
  //           span {
  //             font-size: 0.9em;
  //             // margin-right: 10px;
  //           }
  //           p {
  //             font-size: 0.9em;
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_img {
  //       // width: 25%;
  //       // height: 25%;
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       // margin-left: 17px;
  //       span {
  //         display: inline-block;
  //         font-size: 1em;
  //         margin-bottom: 5px;
  //       }
  //       // p {
  //       //   // font-size: 0.9em;
  //       //   // height: 10vh;
  //       //   // line-height: 2.6vh;
  //       //   overflow: hidden;
  //       //   // text-overflow: ellipsis;
  //       //   // display: -webkit-box;
  //       //   // -webkit-line-clamp: 3;
  //       //   // -webkit-box-orient: vertical;
  //       //   color: #9a9ba8;
  //       // }
  //     }
  //     .bottom-icon {
  //       width: 100%;
  //     }
  //   }
  // }
  .downImg {
    // position: absolute;
    // margin-top: 50%;
    width: 73%;
    // top: 6vh;
    height: 60vh;
    // transform: translateY(-25%);
  }
  .save {
    background-color: #2a2a30;
    height: 6vh;
    border: none;
  }
  .van-icon {
    top: 3.5%;
    transform: translateY(-50%);
  }
}
.boswer_poster {
  .poster_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    background-color: #f7f7f7;
    color: #363636;
    span {
      margin-left: 2%;
    }
  }
  .downImg {
    transform: translate(5vh, 5vh);
    height: 600px;
  }
  // .poster_container {
  //   width: 100%;
  //   height: 500px;
  //   // display: flex;
  //   // justify-content: center;
  //   // align-items: center;
  //   .back_img {
  //     transform: translate(7vh, 5vh);
  //     height: 500px;
  //     width: 75%;
  //     background-size: 100% 500px;
  //     background-repeat: no-repeat;
  //     .isAI_mark {
  //       height: 18%;
  //     }
  //     .back_title {
  //       color: #2d5c88;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       font-size: 18px;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       align-items: center;
  //       // margin-bottom: 1vh;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           align-items: center;
  //           // margin-bottom: 5px;
  //           span,
  //           p {
  //             font-size: 0.2em;
  //           }
  //           span {
  //             margin-right: 10px;
  //           }
  //           p {
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_img {
  //       background-size: 25% 25%;
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       margin: 0 auto;
  //       span {
  //         display: inline-block;
  //         font-size: 0.2rem;
  //         margin-bottom: 0.1rem;
  //       }
  //       p {
  //         font-size: 0.2em;
  //         line-height: 3.2em;
  //         overflow: hidden;
  //         // text-overflow: ellipsis;
  //         // display: -webkit-box;
  //         // -webkit-line-clamp: 4;
  //         // -webkit-box-orient: vertical;
  //         color: #9a9ba8;
  //       }
  //     }
  //   }
  // }
  .save {
    background-color: #2a2a30;
    height: 50px;
    border: none;
    border-radius: 0;
  }
  .van-icon {
    font-size: 28px;
    top: 4%;
    transform: translateY(-50%);
  }
}

</style>
